<template>
  <v-form>
    <v-container v-if="withCampaignName" px-3 pb-0 mb-4 class="blue-grey lighten-5">
      <div class="pb-3 body-2">Name your campaign in a way that makes sense to you.</div>
      <v-text-field
        required
        name="campaignName"
        label="Campaign Name"
        data-vv-as="Campaign Name"
        v-model="campaignName"
        v-validate="'required'"
        :error-messages="errors.first('campaignName')"
        solo
      />
    </v-container>
    <v-container px-3 pt-3 pb-0 class="green lighten-5 border-light">
      <div class="pb-4 body-2">Enter a short phrase / question to prompt your visitors to engage. For example: <span class="light-green--text">"Describe your project?"</span></div>
      <v-text-field
        required
        name="inputPrompt"
        label="Visitor Prompt"
        data-vv-as="Visitor Prompt"
        v-model="inputPrompt"
        v-validate="'required'"
        :error-messages="errors.first('inputPrompt')"
        solo
      />
    </v-container>
    <v-container pa-3 mt-4 class="blue lighten-5 border-light">
      <div class="pb-4 body-2">List questions you want your visitors to provide answers to. For example: <span class="light-blue--text">"What is your phone number?"</span></div>
      <template v-for="(item, index) in questions">
        <v-layout :key="index">
          <v-flex md11 xs10 pr-1 py-0>
            <v-text-field
              required
              :name="`quesiton[${index}]`"
              :label="`Question ${index+1}`"
              data-vv-as="question"
              v-model="item.question"
              v-validate="'required'"
              :error-messages="errors.first(`question[${index}]`)"
              solo
            />
          </v-flex>
          <!--<v-flex md3 py-0 hidden-sm-and-down>-->
            <!--<v-select :items="types" v-model="item.type" solo/>-->
          <!--</v-flex>-->
          <v-flex xs1 pa-0>
            <v-btn :disabled="index == 0" flat icon color="red" @click="removeQuestion(index)">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <v-btn v-if="questions.length < 30" color="pink" dark @click="addQuestion">
        <v-icon dark>add</v-icon> Add Question
      </v-btn>
    </v-container>
  </v-form>
</template>
<script>
export default {
  props: {
    withCampaignName: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    types() {
      return [
        {text:'Text',value:'Free Text'},
        {text:'Email',value:'Email'},
        {text:'Phone',value:'Phone'}
        ];
    },
  },
  data() {
    return {
      campaignName: '',
      inputPrompt: '',
      isValid: true,
      questions: [
        {
          question: '',
          type: 'Free Text',
          mandatory: false,
        },
      ],
    };
  },
  methods: {
    addQuestion() {
      this.questions.push({
        question: '',
        type: 'Free Text',
        mandatory: false,
      });
    },
    removeQuestion(index) {
      this.questions.splice(index, 1);
    },
    async validate() {
      const validatorResult = await this.$validator.validate();
      return validatorResult && this.questions.length > 0;
    },
    async submit() {
      this.isValid = await this.validate();
      if (!this.isValid) {
        return;
      }
      const { campaignName, questions, inputPrompt } = this;
      this.$emit('submit', {
        campaignName,
        inputPrompt,
        questions
      });
    },
  },
};
</script>
<style>
.questions-header h3,
.v-label {
  margin: 0;
}
.question-item {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/LeadQuestion.vue